<template>
  <div>
    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
      <p class="title"><strong>Pesquisa</strong></p>
      <form class="mt-1 w-full" @submit.prevent="reloadTable">
      <div class="flex flex-wrap mb-4 px-4">
          <text-input class="lg:pr-6 w-full lg:w-1/4" label="Nome"  v-model="filters.Import.name"/>

          <select-input v-model="filters.Import.type" class="lg:pr-6 w-full lg:w-1/4" label="Tipo">
            <option :value="null" />
            <option v-for="(value, name, index) in import_type_options" :key="name" :value="name">{{ value }}</option>
          </select-input>
        </div>

        <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
          <button class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
            <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
            Pesquisar
          </button>
          <button
          class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100"
          @click="clearSearch">
            <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
            Limpar
          </button>
        </div>
    </form>

    </div>
    <Head title="Importação" />
    <div class="shadow_box rounded-lg p-6 mt-4">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Importação</h1>
      <data-table v-if="loadTable" v-model:columns="columns" route="import/list"
        :query="getQuery"
        no-data-label="Nenhuma importação cadastrada" no-result-label="Nenhuma importação encontrada">
        <template #table.cell.content.detail="{ value, row }">
          <div class="place-self-center grid-cols-2 gap-4">
            <span class="flex items-center justify-center text-sm" v-if="row.status == 2">
              <button class="rounded p-2 bg-purple-100 text-white" @click.prevent="openModalConfig(row)">
                Ver detalhes<font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
              </button>
            </span>
          </div>
        </template>
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 justify-center">
            <span @click="openModalConfirmDelete(row)"
              class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm"><font-awesome-icon icon="fa-trash-can"
                class="text-white pr-2" />Excluir</span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 justify-center">
            <span @click="openModalConfirmDelete(row)"
              class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm"><font-awesome-icon icon="fa-trash-can"
                class="text-white text-lg pr-2" />Excluir</span>
          </div>
        </template>

        <template #after.reload-button>
          <button class="flex items-end font-roboto font-medium btn-purple uppercase"
            @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block">
              Adicionar Importação</span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" :multipart="true" @confirm="reloadTable"></modal-delete>
    <modal-edit ref="modalEdit" title="Importação" url="import" @submitForm="reloadTable">
      <template #form="{ item }">
        <text-input v-model="item.name" :error="item.errors.name" class="lg:pr-6 w-full lg:w-3/4" label="Nome" required="true"/>
        <select-input v-model="item.type" :error="item.errors.type" class="lg:pr-6 w-full lg:w-1/4" label="Tipo"
          required="true">
          <option :value="null" />
          <option v-for="(value, name, index) in import_type_options" :key="name" :value="name">{{ value }}</option>
        </select-input>

        <select-input v-if="item.type == 'brand'" v-model="item.parent_id" :error="item.errors.parent_id"
          class="lg:pr-6 w-full lg:w-1/4" label="Fornecedor"
          required="true">
          <option :value="null" />
          <option v-for="(value, name, index) in provider_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <select-input v-if="item.type == 'product'" v-model="item.parent_id" :error="item.errors.parent_id"
          class="lg:pr-6 w-full lg:w-1/4" label="Marca"
          required="true">
          <option :value="null" />
          <option v-for="(value, name, index) in brand_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <select-input v-if="item.type == 'market'" v-model="item.parent_id" :error="item.errors.parent_id"
          class="lg:pr-6 w-full lg:w-1/4" label="Rede"
          required="true">
          <option :value="null" />
          <option v-for="(value, name, index) in market_network_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <select-input v-if="item.type == 'market'" v-model="item.zone_id" :error="item.errors.zone_id"
          class="lg:pr-6 w-full lg:w-1/4" label="Região"
          required="true">
          <option :value="null" />
          <option v-for="(value, name, index) in zone_options" :key="name" :value="name">{{ value }}</option>
        </select-input>

        <file-input v-model="item.file" :error="item.errors.file" class="mt-6 w-full" type="file" accept="text/csv"
          label="Arquivo"  required="true"/>
        <div class="mt-6 w-full">
          <span>Regras de importação:</span>
          <span>Cada linha deverá ter os dados de apenas um do tipo informado.</span>

          <button class="flex justify-center items-end font-roboto font-medium btn-primary btn-purple uppercase lg:pr-6"
            @click.prevent="exportData(item.type)" v-if="item.type">
            <font-awesome-icon icon="fa-solid fa-table" class="text-white text-lg mr-0 lg:mr-2" /><span class="">
              Fazer download do modelo</span>
          </button>
          <div class="p-2 table w-full">
            <div class="table-header-group w-full bg-purple-100 text-white text-center">
              <div class="table-cell">Coluna</div>
              <div class="table-cell">Campo</div>
              <div class="table-cell">Obrigatório</div>
              <div class="table-cell">Descrição</div>
            </div>
            <div class="table-row-group w-full" v-for="(user, index) in table_models" :key="index">
              <div class="table-row bg-indigo-300 text-center even:bg-even_table odd:bg-odd_table" v-for="(i, a) in user"
                v-if="item.type == index">
                <div class="table-cell">{{ i.coluna }} </div>
                <div class="table-cell">{{ i.nome }}</div>
                <div class="table-cell">{{ i.obrigatorio }}</div>
                <div class="table-cell">{{ i.descricao }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal-edit>
    <modal ref="modalConfig" size="modal-lg" :modal-scrollable="true" :modal-backdrop="true">
      <template #header="{ item }">
        <div class="text-gray-777 font-roboto uppercase">
          <span>Resultado da importação</span>
        </div>
      </template>
      <template #body>
        <form action="">
          <div class="flex">
            <div class="w-full m-2">
              O arquivo não foi importados pelos seguintes erros
              <table class="w-full">
                <tbody>
                  <tr class="table-header-group w-full bg-purple-100 text-white text-center">
                    <td>Nº da linha</td>
                    <td>Resultado</td>
                  </tr>
                  <tr v-for="(itens, index) in this.rows" :key="index" class=" text-black bg-indigo-300 text-center even:bg-even_table odd:bg-odd_table">
                    <td>{{ itens.row }}</td>
                    <td>{{ itens.result }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </template>
      <template #footer>
        <button type="button"
          class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
          @click.prevent="closeModalConfig">Fechar</button>
      </template>
    </modal>
  </div>
</template>

<script>
import { Head, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'
import SelectInput from '@/Shared/SelectInput'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    TextInput,
    DataTable,
    SelectInput,
    FileInput,
    Modal,
  },
  layout: Layout,
  data() {
    return {
      loadTable: true,
      rows: null,
      columns: [
        {
          uniqid: 'name',
          label: 'Nome',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'type',
          label: 'Tipo',
          field: 'type',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.type_label ? row.type_label : ''
        },
        {
          uniqid: 'status',
          label: 'Status',
          field: 'status',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.status_label ? row.status_label : ''
        },
        {
          uniqid: 'detail',
          label: 'Detalhes',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
      search: {
          name: '',
          type: '',
          status: '',
      },
    }
  },
  props: {
    import_type_options: Object,
    provider_options: Object,
    brand_options: Object,
    market_network_options: Object,
    zone_options: Object,
    type_select: String,
    table_models: Object,
  },

  computed: {
    getQuery() {
      return Object.entries( this.getFilters() ).map( ( [key, val] ) => `search2[${key}]=${val}` ).join( '&' )
    },
  },

  methods: {
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/import/${item.id}`, `Deseja realmente excluir a importação ${item.name}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        name: item.name,
        file: item.file,
        parent_id: item.parent_id,
        type: item.type,
        zone_id: item.zone_id,
        errors: {}
      });
    },
    openModalConfig(item) {
      this.rows = item.rows,
      this.$refs.modalConfig.showModal = true;
    },
    closeModalConfig() {
      this.$refs.modalConfig.showModal = false;
    },

    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    clearSearch() {
      this.clearFilters()
      this.reloadTable()
    },
    exportData(type) {
      window.open('/import/export/'+type, '_blank', 'noreferrer');
    },
  },

  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent( 'Import' )

    const clearFilters = () => clearFiltersComponent( 'Import', { type: '' } )
    const getFilters = () => getFiltersComponent( 'Import' )

    return { 
      getFilters,
      clearFilters, 
      filters: filtersStore.filters
    }
  }
}
</script>
